import type { LocationDescriptor } from 'history';
import { Navigate } from 'react-router-dom';
import { useStaticContext } from '../ServerApp/staticContext';

interface Props {
  to: LocationDescriptor;
  status: number;
}

export const RedirectWithStatus = (props: Props) => {
  const { to, status } = props;
  const context = useStaticContext();
  context.statusCode = status;
  context.url = to as string;
  return <Navigate replace to={to} />;
};
